import {ReactNode, useMemo} from 'react';

import {useUsersRepository} from '@/dataSource/src/api/users/useRepository';

import {ModakAuthentication} from './ModakAuthentication';

type AuthenticationProps = {
  children: ReactNode;
};

function Authentication({children}: AuthenticationProps) {
  useUsersRepository();

  return useMemo(() => {
    return <ModakAuthentication>{children}</ModakAuthentication>;
  }, [children]);
}

export default Authentication;
